module.exports = __webpack_public_path__ + "img/icon-arrow-left.b896c9ad.svg";